export default __webpack_public_path__ + "static/media/profile.66b9a992.svg";